export default "Conformité Décret Tertiaire — OPERAT 2030 | Solution Éco France";
